<template>
  <div class="card-body px-0 pt-0 pb-2 vh-50">
    <div class="container py-4">
      <form
        class="w-100 px-md-5"
        method="POST"
        v-on:submit.prevent="submitFormCliente"
        id="form-cliente"
      >
        <div class="row">
          <div class="form-group col-md-4">
            <label>Nombre*</label>
            <input
              type="text"
              class="form-control"
              name="nombre"
              v-model="nombre"
              required
            />
          </div>
          <div class="form-group col-md-4">
            <label>Apellido paterno*</label>
            <input
              type="text"
              class="form-control"
              name="paterno"
              v-model="paterno"
              required
            />
          </div>
          <div class="form-group col-md-4">
            <label>Apellido materno</label>
            <input
              type="text"
              class="form-control"
              placeholder="Opcional"
              name="materno"
              v-model="materno"
            />
          </div>
          <div class="form-group col-md-6">
            <label>Correo electrónico*</label>
            <input
              type="email"
              class="form-control"
              name="correo"
              v-model="correo"
              required
            />
          </div>
          <div class="form-group col-md-3">
            <label>Celular*</label>
            <input
              type="tel"
              class="form-control"
              name="celular"
              v-model="celular"
              required
              minlength="10"
              maxlength="10"
            />
          </div>
          <div class="form-group col-md-3">
            <label>Teléfono</label>
            <input
              type="tel"
              class="form-control"
              placeholder="Opcional"
              name="telefono"
              v-model="telefono"
              maxlength="10"
            />
          </div>
          <div class="form-group col-md-4">
            <label>RFC*</label>
            <input
              type="text"
              class="form-control"
              name="rfc"
              v-model="rfc"
              required
            />
          </div>
          <div class="form-group col-md-5">
            <label>Empresa*</label>
            <input
              type="text"
              class="form-control"
              v-model="empresa"
              name="empresa"
              required
            />
          </div>
          <div class="form-group col-md-3">
            <label>Tipo persona*</label>
            <select
              name="tipo_persona"
              v-model="tipo_persona"
              required
              class="form-control"
            >
              <option value="">Seleccione</option>
              <option value="FISICA">FISICA</option>
              <option value="MORAL">MORAL</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label>Estado*</label>
            <select
              name="estado"
              id="estado"
              class="form-control"
              @change="getMunicipiosByEstado($event.target.value)"
              v-model="estado"
              required
            >
              <option value="">Seleccione</option>
              <option
                :value="estado.id"
                v-for="estado in estados"
                :key="estado.id"
              >
                {{ estado.nombre }}
              </option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label>Municipio*</label>
            <div class="position-relative">
              <select
                name="municipio"
                id="municipio"
                class="form-control"
                v-model="municipio"
                required
              >
                <option value="">Seleccione</option>
                <option
                  :value="municipio.id"
                  v-for="municipio in listMunicipios"
                  :key="municipio.id"
                >
                  {{ municipio.nombre }}
                </option>
              </select>
              <div
                class="spinner-border text-primary position-absolute top-0 mt-2 me-1 end-0 spinner-border-sm"
                role="status"
                v-show="showSpinnerMunicipio"
              >
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <div class="text-center mt-1">
            <button
              v-if="modo == 'crear'"
              type="submit"
              class="btn btn-primary me-2 btn-sm"
              :disabled="isLoadingSubmit"
            >
              <span
                v-if="isLoadingSubmit"
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              Registrar
            </button>
            <button
              v-else-if="modo == 'editar'"
              type="submit"
              class="btn btn-primary me-2 btn-sm"
              :disabled="isLoadingSubmit"
            >
              <span
                v-if="isLoadingSubmit"
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              Modificar
            </button>
            <router-link
              :to="{ name: 'clientes' }"
              class="btn btn-danger text-white btn-sm"
              >Cancelar</router-link
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import appApi from "@/services/api";
import { showToast, exceptionRequestMsg } from "@/assets/js/util";
export default {
  data() {
    return {
      showSpinnerMunicipio: false,
      isLoadingSubmit: false,
      nombre: this.cliente.nombre,
      paterno: this.cliente.paterno,
      materno: this.cliente.materno,
      correo: this.cliente.correo,
      celular: this.cliente.celular,
      telefono: this.cliente.telefono,
      rfc: this.cliente.rfc,
      empresa: this.cliente.empresa,
      tipo_persona: this.cliente.tipo_persona,
      estado: this.cliente.estado_id,
      municipio: this.cliente.municipio_id,
      listMunicipios: this.municipios,
    };
  },
  props: {
    cliente: {
      type: Object,
      required: false,
      default: () => ({
        nombre: "",
        paterno: "",
        materno: "",
        correo: "",
        celular: "",
        telefono: "",
        rfc: "",
        empresa: "",
        tipo_persona: "",
        estado: "",
        municipio: "",
      }),
    },
    estados: {
      type: Object,
      required: true,
    },
    municipios: {
      type: Object,
      required: true,
    },
    modo: {
      type: String,
      required: true,
    },
  },
  methods: {
    async getMunicipiosByEstado(estado_id) {
      try {
        this.listMunicipios = [];
        this.showSpinnerMunicipio = true;
        const response = await appApi().get(`municipios/${estado_id}`);
        this.listMunicipios = response.data;
        this.showSpinnerMunicipio = false;
        return response.data;
      } catch (e) {
        this.showSpinnerMunicipio = false;
        console.error(e);
      }
    },
    async submitFormCliente() {
      this.isLoadingSubmit = true;
      const form = document.getElementById("form-cliente");
      const formData = new FormData(form);

      if (this.modo === "crear") {
        await this.storeCliente(formData);
      } else if (this.modo === "editar") {
        await this.updateCliente(formData);
      }
    },
    async storeCliente(formData) {
      try {
        const response = await appApi().post("clientes/store", formData);
        const { status, message, cliente } = response.data;

        console.log(cliente);

        if (!status) {
          this.isLoadingSubmit = false;
          showToast(message, "error");
          return;
        }

        showToast(message, "success");
        this.$router.push({
          name: "editar-cliente",
          params: { cliente_id: cliente.id },
        });
      } catch (e) {
        this.isLoadingSubmit = false;
        exceptionRequestMsg(e);
      }
    },
    async updateCliente(formData) {
      formData.append("_method", "PUT");
      try {
        const response = await appApi().post(
          `clientes/update/${this.cliente.id}`,
          formData
        );
        const { status, message } = response.data;

        if (!status) {
          this.isLoadingSubmit = false;
          showToast(message, "error");
          return;
        }

        showToast(message, "success");
        this.$router.push({
          name: "clientes",
        });
      } catch (e) {
        this.isLoadingSubmit = false;
        exceptionRequestMsg(e);
      }
    },
  },
};
</script>

<style></style>
